import Vue from 'vue';
import Router from 'vue-router';
import RemoteLoginForm from '@/components/RemoteLoginForm';
import eventsMainTemplate from '@/components/eventsMainTemplate';
import eventSelection from '@/components/eventSelection';
import candidate from '@/components/candidate';
import availabilityTpl from '@/components/ey/availability';
import candidate2Tpl from '@/components/candidate2';
import candidate3Tpl from '@/components/candidate3';
import rating2Tpl from '@/components/rating2';
import rating3Tpl from '@/components/rating3';
import academic_career from '@/components/ey/academic_career';
import secteur from '@/components/ey/secteur'
import candidate_wishes0 from '@/components/ey/candidate_wishes0.vue';
import candidate_wishes1 from '@/components/ey/candidate_wishes1.vue';
import candidate_wishes2 from '@/components/ey/candidate_wishes2.vue';
import candidate_wishes3 from '@/components/ey/candidate_wishes3.vue';
import candidate_wishes4 from '@/components/ey/candidate_wishes4.vue';
import candidate_wishes from '@/components/ey/candidate_wishes.vue';

import association_commitment from '@/components/ey/association_commitment';
import opinionTpl from '@/components/ey/opinion';
import ratingEyTpl from '@/components/ey/ratingEy';
import access from '@/components/access';
import rating from '@/components/rating';
import pools from '@/components/pools';
import singlePoolTpl from '@/components/singlePoolTpl';
import ratingDevoTpl from '@/components/ratingDevo';
import candidateSelectionTpl from '@/components/candidateSelection';

Vue.use(Router);

const router = new Router({
	base: __dirname,
	routes: [
		{
			path: '/',
			component: RemoteLoginForm,
     		name : 'loginPage',
			meta : {title : 'Connexion'}
		},
		{
			path: '/events',
			component: eventsMainTemplate,
			meta : {title : 'Accueil'},
			children: [
				{
					path: 'new',
					name : 'newEvent',
					component: eventSelection,
					meta : {title : 'Accueil'}
				},
				{
					path: 'candidate',
					name : 'candidateTpl',
					component: candidate,
					meta : {title : 'Informations candidat'}
				},
				{
					path: 'candidate2',
					name : 'candidate2Tpl',
					component: candidate2Tpl,
					meta : {title : 'Informations candidat2'}
				},
				{
					path: 'candidate3',
					name : 'candidate3Tpl',
					component: candidate3Tpl,
					meta : {title : 'Informations candidat3'}
				},
				{
					path: 'availability',
					name : 'availabilityTpl',
					component: availabilityTpl,
					meta : {title : 'Disponiblité du candidat'}
				},
				{
					path: 'academic_career',
					name : 'academic_careerTpl',
					component: academic_career,
					meta : {title : 'Parcours académique'}
				},
				{
					path: 'secteur',
					name : 'secteurTpl',
					component: secteur,
					meta : {title : 'Secteurs'}
				},
				{
					path: 'candidate_wishes0',
					name : 'candidate_wishes0Tpl',
					component: candidate_wishes0,
					meta : {title : 'Souhait du candidat'}
				},
				{
					path: 'candidate_wishes1',
					name : 'candidate_wishes1Tpl',
					component: candidate_wishes1,
					meta : {title : 'Souhait du candidat'}
				},
				{
					path: 'candidate_wishes2',
					name : 'candidate_wishes2Tpl',
					component: candidate_wishes2,
					meta : {title : 'Souhait du candidat'}
				},
				{
					path: 'candidate_wishes3',
					name : 'candidate_wishes3Tpl',
					component: candidate_wishes3,
					meta : {title : 'Souhait du candidat'}
				},
				{
					path: 'candidate_wishes4',
					name : 'candidate_wishes4Tpl',
					component: candidate_wishes4,
					meta : {title : 'Souhait du candidat'}
				},
				{
					path: 'candidate_wishes',
					name : 'candidate_wishesTpl',
					component: candidate_wishes,
					meta : {title : 'Souhait du candidat'}
				},
				{
					path: 'association_commitment',
					name : 'association_commitmentTpl',
					component: association_commitment,
					meta : {title : 'Engagement associatif'}
				},
				{
					path: 'access',
					name : 'accessTpl',
					component: access,
					meta : {title: 'Formulaire completé'}
				},
				{
					path: 'opinion',
					name : 'opinionTpl',
					component: opinionTpl,
					meta : {title: 'Recommandation interviewer'}
				},
				{
					path: 'ratingEy',
					name : 'ratingEyTpl',
					component: ratingEyTpl,
					meta : {title: 'Appréciation'}
				},
				{
					path: 'rating2',
					name : 'rating2Tpl',
					component: rating2Tpl,
					meta : {title: 'Appréciation'}
				},
				{
					path: 'rating3',
					name : 'rating3Tpl',
					component: rating3Tpl,
					meta : {title: 'Appréciation'}
				},
				{
					path: 'rating',
					name : 'ratingTpl',
					component: rating,
					meta : {title: 'Évaluation du candidat'}
				},
				{
					path: 'ratingDevo',
					name : 'ratingDevoTpl',
					component: ratingDevoTpl,
					meta : {title: 'Évaluation du candidat'}
				},
				{
					path: 'pools',
					name : 'poolsTpl',
					component: pools,
					meta : {title: 'Catégorisation multiple'}
				},
				{
					path: 'singlePoolTpl',
					name : 'singlePoolTpl',
					component: singlePoolTpl,
					meta : {title: 'Catégorisation simple'}
				},
				{
					path: 'candidateSelection',
					name : 'candidateSelectionTpl',
					component: candidateSelectionTpl,
					meta : {title: 'Sélection du candidat'}
				},
			]
		}
	],
});


router.beforeEach((to, from, next) => {
	if(to.meta && to.meta.title) document.title = to.meta.title + " - Remo'te";
	next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js